<template>
	<div class="group-2">
		<Group232
			:email1="group232Props.email1"
			:email2="group232Props.email2"
			:className="group232Props.className"
			:type="inputType"
			:modelValue="modelValue"
			:autocomplete="'current-password'"
			autocapitalize="off"
			:spellcheck="false"
			@update:modelValue="handleUpdate"
			@focus="handleFocus"
			@blur="handleBlur"
			@keyup="handleKeyup"
		/>

		<!-- Иконка зачеркнутого глаза (пароль скрыт) -->
		<img
			v-if="!showPassword"
			class="invisible-1"
			src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/invisible-1.svg"
			alt="Скрытый пароль"
			@click="togglePassword"
		/>

		<!-- Иконка открытого глаза (пароль виден) -->
		<svg
			v-else
			class="invisible-1"
			@click="togglePassword"
			width="17"
			height="12"
			viewBox="0 0 17 12"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.6488 5.15877C15.0718 2.08183 11.9498 0 8.37499 0C4.8002 0 1.67731 2.08328 0.101182 5.15906C0.0346595 5.29065 0 5.43604 0 5.58348C0 5.73093 0.0346595 5.87632 0.101182 6.00791C1.67818 9.08485 4.8002 11.1667 8.37499 11.1667C11.9498 11.1667 15.0727 9.08339 16.6488 6.00761C16.7153 5.87603 16.75 5.73064 16.75 5.58319C16.75 5.43575 16.7153 5.29036 16.6488 5.15877ZM8.37499 9.77084C7.54678 9.77084 6.73717 9.52525 6.04854 9.06512C5.35991 8.60499 4.82319 7.95099 4.50624 7.18583C4.1893 6.42066 4.10637 5.57869 4.26795 4.7664C4.42953 3.9541 4.82835 3.20796 5.41398 2.62233C5.99961 2.03669 6.74575 1.63787 7.55805 1.4763C8.37035 1.31472 9.21231 1.39765 9.97748 1.71459C10.7426 2.03153 11.3966 2.56825 11.8568 3.25689C12.3169 3.94552 12.5625 4.75513 12.5625 5.58334C12.5628 6.13333 12.4546 6.67797 12.2443 7.18614C12.0339 7.69432 11.7255 8.15605 11.3366 8.54495C10.9477 8.93385 10.486 9.24229 9.9778 9.45263C9.46963 9.66298 8.92498 9.77111 8.37499 9.77084ZM8.37499 2.79167C8.12582 2.79515 7.87825 2.83222 7.63898 2.90188C7.83621 3.1699 7.93085 3.49973 7.90575 3.83155C7.88065 4.16337 7.73746 4.4752 7.50216 4.71051C7.26686 4.94581 6.95502 5.08899 6.6232 5.11409C6.29139 5.1392 5.96156 5.04455 5.69354 4.84733C5.54091 5.40961 5.56846 6.0056 5.77231 6.55141C5.97615 7.09722 6.34602 7.56536 6.82986 7.88994C7.31371 8.21453 7.88715 8.37921 8.46949 8.36082C9.05183 8.34242 9.61374 8.14187 10.0761 7.78739C10.5385 7.43292 10.8781 6.94236 11.0471 6.38478C11.2161 5.82719 11.206 5.23065 11.0182 4.67912C10.8303 4.12759 10.4743 3.64884 10.0002 3.31025C9.52601 2.97167 8.95762 2.7903 8.37499 2.79167Z"
				fill="black"
				fill-opacity="0.5"
			/>
		</svg>
	</div>
</template>

<script>
import Group232 from './Group232'

export default {
	name: 'Group227',
	components: {
		Group232,
	},
	props: {
		// В AuthPage: :group232Props="group227Props.group232Props"
		group232Props: {
			type: Object,
			default: () => ({}),
		},
		// v-model
		modelValue: {
			type: String,
			default: '',
		},
		// Можно переопределять при необходимости
		autocomplete: {
			type: String,
			default: 'current-password', // для формы логина это удобно
		},
	},
	emits: ['update:modelValue', 'focus', 'blur', 'input', 'keyup'],
	data() {
		return {
			showPassword: false,
		}
	},
	computed: {
		inputType() {
			return this.showPassword ? 'text' : 'password'
		},
	},
	methods: {
		togglePassword() {
			this.showPassword = !this.showPassword
		},
		handleUpdate(value) {
			this.$emit('update:modelValue', value)
			this.$emit('input', value)
		},
		handleFocus(event) {
			this.$emit('focus', event)
		},
		handleBlur(event) {
			this.$emit('blur', event)
		},
		handleKeyup(event) {
			this.$emit('keyup', event)
		},
	},
}
</script>

<style>
.group-2,
.group-227 {
	height: 90px;
	margin-left: 18px;
	margin-top: 30px;
	position: relative;
	width: 100%;
	max-width: 435px;
}

.invisible-1,
.invisible-1-1 {
	height: 18px;
	right: 20px;
	position: absolute;
	top: 54px;
	width: 18px;
	cursor: pointer;
	z-index: 2;
	transition: opacity 0.2s ease;
}

.invisible-1:hover,
.invisible-1-1:hover {
	opacity: 0.7;
}

/* Адаптивность */
@media (max-width: 767px) {
	.group-2,
	.group-227 {
		margin-left: 0;
		width: 100%;
		max-width: 100%;
	}
	.invisible-1,
	.invisible-1-1 {
		right: 15px;
	}
}
</style>
